import User from "./user";
import settingsKeyPrefix from "../../gd/settings/local-settings/settings-key";
import LocalSettings from "../../gd/settings/local-settings/local-settings"
import UserClientData from "../../client-data/user/user";
import DatetimeUtils from "../../gd/utils/datetime-utils";
import UserSettings from "../../client-data/user-settings/user-settings";
import {EVENT_BUS_USER_LAST_VISIT_MY_WORK, EVENT_BUS_USER_LAST_VISIT_NOTIFICATIONS} from "./bus";
import UserMenuSettings from "../../manager/user/menu-settings";
import {CurrentUserAccess} from "./access/acl";
import {CompanyRole} from "../../gd/const/company-role"
import PersonalViews from "../view/personal-view/personal-views";

export default class CurrentUser extends User {

    public localSettings                : LocalSettings

    public lastVisitMyWork             : Moment
    public lastVisitNotifications      : Moment

    public clientData                   : any       // po hodu eto user settings data
    public formatSettings               : any
    public email                        : string
    public phone?                       : string
    public timezone                     : string
    public icon                         : string
    public created                      : Moment

    public settings                     : UserSettings

    private _weekends                   : any
    public personalViews                : PersonalViews

    constructor(data: any) {

        super(data) // id name avatar color

        this.formatSettings     = data.datetimeFormat

        this.email              = data.email
        this.timezone           = data.timezone
        this.icon               = data.icon
        this.created            = data.created ? DatetimeUtils.datetimeToMoment(data.created):moment()

        this.clientData         = UserClientData.normalize(_.get(data,'clientData', {}))

        this.settings           = new UserSettings(this.clientData)

        this.personalViews      = new PersonalViews()


        const now = moment().toJSON();
        this.localSettings = new LocalSettings("gd.me",{
            last_visit_my_work          : now,
            last_visit_notifications    : now
        });

        this.lastVisitMyWork        = moment(this.localSettings.get('last_visit_my_work'))
        this.lastVisitNotifications = moment(this.localSettings.get('last_visit_notifications'))

    }

    get acl():CurrentUserAccess {
        return new CurrentUserAccess(this)
    }

    get menu():UserMenuSettings {
        // console.warn("uze ne nado ... get rid of gd.user.menu it happens in user settings ")
        // this is deprecated usage
        return this.settings.menu
    }

    get isClient():boolean {
        return gd.company && gd.company.role === gd.const.companyRole.CLIENT
    }

    get isUser():boolean {
        return gd.company && gd.company.role >= CompanyRole.USER
    }

    // Deprecated
    isCustomer() {
        return this.isClient
    }

    // deprecated -> gd.user.acl.isManager
    isManager() {
        return gd.company && gd.company.role === gd.const.companyRole.MANAGER
    }

    isCompanyManager(companyId:ID) {
        const company = gd.session.companies.get(companyId);
        return (company && company.role>=gd.const.companyRole.MANAGER);
    }

    isCompanyGuest(companyId:ID) {
        const company = gd.session.companies.get(companyId);
        return (company && company.role<=gd.const.companyRole.GUEST);
    }

    registerVisitMyWork() {
        this.lastVisitMyWork = moment();
        this.localSettings.set('last_visit_my_work',this.lastVisitMyWork.toJSON());

        gd.bus.triggerEvent(EVENT_BUS_USER_LAST_VISIT_MY_WORK)
    }

    registerVisitNotifications() {
        this.lastVisitNotifications = moment();
        this.localSettings.set('last_visit_notifications',this.lastVisitNotifications.toJSON());

        gd.bus.triggerEvent(EVENT_BUS_USER_LAST_VISIT_NOTIFICATIONS)
    }

    init() {
        console.log("23982376 deprecated call")
        // this is done in constructor


        // const now = Moment().toJSON();
        // this.localSettings = new LocalSettings("gd.me",{
        //     last_visit_my_work: now,
        //     last_visit_notifications: now
        // });
        //
        // this.lastVisitMyWork = Moment(this.localSettings.get('last_visit_my_work'));
        // this.lastVisitNotifications = Moment(this.localSettings.get('last_visit_notifications'));
    }

    // po hodu eto na reset settings ?
    clearLocalStorage() {
        localStorage.clear();
        localStorage.setItem(settingsKeyPrefix() + 'gd.userId', ''); // for user switch listener

        sessionStorage.clear();
    }

    // get user's defualt weekends - used in calendar to mark weekends (at least)
    weekends() {

        // console.log("weekends() called");

        if (this._weekends) return this._weekends;

        // console.log("no cache found -> recalculate");

        let weekends = [0,6]; // Sat, Sun

        const companyId = gd.companyId;

        if (companyId) {
            const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, this.id);
            if (companyUser && companyUser.workWeek) {
                const workweek = companyUser.workWeek;

                // CAREFULL WORKWEEK is MOD-SUN (!!!) while in weekends 0 = SUNDAY (!)
                weekends=[];
                if (workweek[0]===0) weekends.push(1);
                if (workweek[1]===0) weekends.push(2);
                if (workweek[2]===0) weekends.push(3);
                if (workweek[3]===0) weekends.push(4);
                if (workweek[4]===0) weekends.push(5);
                if (workweek[5]===0) weekends.push(6);
                if (workweek[6]===0) weekends.push(0);
            }
        }

        // cache
        this._weekends = weekends;

        return weekends;

    }

    saveClientData() {
        // console.log("save client settings (saveClientData)")
        return gd.api.MyAccount.updateClientData({clientData: this.clientData});
    }


}
